import {
  DataType,
  type TimeseriesData,
  type TimeseriesDataSet,
} from '../types';

export const trimEmptyTimeseriesEdges = (
  data: TimeseriesData[]
): TimeseriesDataSet => {
  const hasValueAt = (index: number): boolean =>
    data.some((series) => {
      const value = series.timeseries[index]?.value;
      return value !== null && value !== undefined;
    });

  const length = data[0]?.timeseries.length ?? 0;

  let firstIndex = 0;
  while (firstIndex < length && !hasValueAt(firstIndex)) {
    firstIndex++;
  }
  if (firstIndex === length) {
    return { type: DataType.TIMESERIES, data: [] };
  }

  let lastIndex = length - 1;
  while (lastIndex > firstIndex && !hasValueAt(lastIndex)) {
    lastIndex--;
  }

  return {
    type: DataType.TIMESERIES,
    data: data.map((series) => ({
      ...series,
      timeseries: series.timeseries.slice(firstIndex, lastIndex + 1),
    })),
  };
};
